import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { ToasterService } from '../../../services/toaster.service';
import { ToastService } from '../../../services/toast.service';
import { EnvironmentService } from '../../../services/environment.service';
import { lastValueFrom } from 'rxjs';
import { EmployeeListService } from '../../../services/employee/employee-list.service';
import { CommonService } from '../../../services/common/common.service';
import { CompanyService } from '../../../services/company/company.service';
import { WidgetService } from '../../../services/widget.service';
import { MasterService } from '../../../services/policy-allowance-benefits-service/master.service';
import { RolesAndPermissionService } from '../../../services/roles-and-permission/roles-and-permission.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  formdata!: FormGroup;
  userName = '^[a-zA-Z0-9!@#$%^&*()_+=-]*$';
  submit = false;
  passwordFieldType: string = 'password';
  errMessageEmail: any = '';
  errMessagePassword: any = '';
  errMessageBlocked: any = '';
  forgotPassword: boolean = false;
  subDomain: any = '';
  isModalOpen = false;
  userId: any = '';
  current_login_time: any;

  constructor(
    private readonly formbulider: FormBuilder,
    private readonly auth: AuthService,
    private readonly toast: ToasterService,
    private readonly toaster: ToastService,
    private readonly router: Router,
    private readonly environmentService: EnvironmentService,
    private readonly employeeService: EmployeeListService,
    private readonly commonService: CommonService,
    private readonly companyService: CompanyService,
    private widgetService: WidgetService,
    private readonly masterServices: MasterService,
    private readonly permissionService: RolesAndPermissionService,
  ) { }

  ngOnInit(): void {
    this.formdataChange('');
    this.subDomain = this.environmentService.getSubDomain();

    const colorPallette = localStorage.getItem('color');
    // console.log(colorPallette);
    // this.widgetService.loadThemeFromLocalStorage();
    if (colorPallette) {
      const color = JSON.parse(colorPallette);
      this.setcolorPallete(color);
    } else {
      document.documentElement.style.setProperty('--header-color', '#2A9D8E');
      document.documentElement.style.setProperty(
        '--header-text-color',
        '#ffffff',
      );
      document.documentElement.style.setProperty(
        '--sidebar-text-color',
        '#ffffff',
      );
      document.documentElement.style.setProperty('--sidebar-color', '#2f4050');
      document.documentElement.style.setProperty(
        '--link-active-bg-color',
        '#e0e0e0',
      );
      document.documentElement.style.setProperty(
        '--link-active-text-color',
        '#006fc2',
      );
      document.documentElement.style.setProperty('--title-color', '#000000');
      document.documentElement.style.setProperty(
        '--link-hover-bg-color',
        '#e0e0e0',
      );
      document.documentElement.style.setProperty(
        '--link-hover-text-color',
        '#006fc2',
      );
    }
  }

  setcolorPallete(colorPallette: any) {
    document.documentElement.style.setProperty(
      '--header-color',
      colorPallette?.bg_color,
    );
    document.documentElement.style.setProperty(
      '--header-text-color',
      colorPallette?.bg_text_color,
    );
    document.documentElement.style.setProperty(
      '--sidebar-text-color',
      colorPallette?.sidebar_text_color,
    );
    document.documentElement.style.setProperty(
      '--sidebar-color',
      colorPallette?.sidebar_color,
    );
    document.documentElement.style.setProperty(
      '--link-active-bg-color',
      colorPallette?.link_active_bg_color,
    );
    document.documentElement.style.setProperty(
      '--link-active-text-color',
      colorPallette?.link_active_text_color,
    );
    document.documentElement.style.setProperty(
      '--title-color',
      colorPallette?.title_color,
    );
    document.documentElement.style.setProperty(
      '--link-hover-bg-color',
      colorPallette?.link_hover_bg_color,
    );
    document.documentElement.style.setProperty(
      '--link-hover-text-color',
      colorPallette?.link_hover_text_color,
    );
  }

  get form() {
    return this.formdata.controls;
  }

  async login() {
    this.submit = true;
    if (this.formdata.invalid) return;

    try {
      if (!this.forgotPassword) {
        // 🔐 Normal Login
        const username = this.formdata.get('username')?.value?.trim();
        const password = this.auth.encryptData(
          this.formdata.get('password')?.value,
        );

        const response: any = await lastValueFrom(
          this.auth.loginUser(username, password),
        );
        await this.handleLoginResponse(response);
      } else {
        // 🔄 Forgot Password Flow
        const formData = {
          username: this.formdata.get('username')?.value?.trim(),
          login_url: window.location.origin + '/',
        };

        const resp: any = await lastValueFrom(
          this.auth.ChangePassword(formData),
        );
        if (resp?.status === 200) {
          this.toaster.success(resp.message);
          this.forgotPassword = false;
          window.location.href = window.location.origin + '/';
        } else {
          this.toaster.failure(resp?.message || 'Failed to reset password.');
        }
      }
    } catch (err: any) {
      this.handleLoginError(err);
    }
  }

  async loginSSO() {
    const username = this.formdata.get('username')?.value?.trim();
    if (!username) {
      if (this.formdata.get('username')?.invalid) {
        this.formdata.get('username')?.markAsTouched();
      }
      this.errMessageEmail = 'Username is required for SSO Login';
      return;
    }

    try {
      const response: any = await lastValueFrom(
        this.auth.loginWithSSO(username),
      );
      await this.handleLoginResponse(response);
    } catch (err: any) {
      this.handleLoginError(err);
    }
  }

  private async handleLoginResponse(response: any) {
    if (response.status === 'OTP_REQUIRED') {
      localStorage.setItem('otp_user_id', response.userId);
      this.router.navigate(['otp']);
      return;
    }

    if (response.status === 'GA_OTP_REQUIRED') {
      localStorage.setItem('otp_user_id', response.userId);
      if (response.type == 1) {
        this.router.navigate(['/ga-setup']);
      } else if (response.type == 2) {
        this.router.navigate(['/ga-verify']);
      } else if (response.type == 3) {
        this.router.navigate(['/ga-otp']);
      }
      return;
    }
    const {
      id,
      employee_login_id,
      name,
      firstname,
      role,
      accessToken,
      client_id,
      status,
      companyID,
      locationID,
      group_id,
      first_login,
      acknowledged,
      icon,
      role_type,
      super_user_company_id,
      is_help_desk_supervisor
    } = response;

    if (status !== 'Success') {
      const msg =
        status === 'Failure'
          ? 'Company is deactivated. Please contact the admin.'
          : 'Login failed. Please try again.';
      this.toaster.failure(msg);
      return;
    }

    const userObj = {
      userID: id,
      employee_login_id,
      name,
      firstname,
      companyID,
      locationID,
      role,
      client: companyID && companyID.length === 0 && role == '2',
      group_id,
      client_id,
      accessToken,
      status,
      first_login,
      acknowledged,
      icon,
      role_type,
      super_user_company_id,
      is_help_desk_supervisor
    };

    // ✅ Save user and clear old data
    this.auth.updateUser(userObj);
    localStorage.removeItem('default_company');
    this.errMessageEmail = '';
    this.errMessagePassword = '';
    this.toaster.success('Login Successful');
    const resp: any = await lastValueFrom(
      this.permissionService.getPermission(group_id || 0),
    );

    localStorage.setItem('menus', JSON.stringify(resp.data));

    const userData = JSON.parse(localStorage.getItem('auth_user') || '{}');
    if (!userData) return;

    // 🧭 Redirect based on role_type
    if (
      userData.role_type === 'super_admin' ||
      userData.role_type === 'admin' ||
      userData.role_type === 'sub_admin'
    ) {
      this.router.navigate(['app/company']);
      return;
    }

    if (
      userData.role_type === 'employee' ||
      userData.role_type === 'super_user'
    ) {
      if (userData.role_type === 'super_user' && !userData.userID) {
        this.router.navigate(['app/company']);
        return;
      }

      // 🧾 Fetch acknowledgement policies
      const ackResp: any = await lastValueFrom(
        this.masterServices.getAllAcknowledgement(),
      );
      const acknowledgeData = ackResp?.data ?? [];
      const employeeAcknowledged = userData?.acknowledged ?? [];

      const allAcknowledged = acknowledgeData.every((policy: any) =>
        employeeAcknowledged?.some(
          (emp: any) =>
            emp?.policy_id === policy.id && emp?.acknowledged === true,
        ),
      );

      if (userData?.first_login == 1) {
        this.router.navigate(['app/employee/employee-dashboard'], {
          queryParams: { firstLogin: userData.first_login },
        });
        return;
      }

      if (!allAcknowledged) {
        this.router.navigate(['app/employee/employee-dashboard'], {
          queryParams: { acknowledge: true },
        });
        return;
      }

      // 📊 Check profile completion
      const empResp: any = await lastValueFrom(
        this.employeeService.getnewEmployee(userData.userID),
      );
      const employeeData = empResp?.data?.employee;

      const percentage = Math.round(
        this.commonService.calculateProfileCompletion(employeeData),
      );

      const companyResp: any = await lastValueFrom(
        this.companyService.getParametersById(userData.companyID),
      );
      const companyPercentage =
        companyResp?.data?.profile_completion_percentage ?? 0;

      if (percentage < companyPercentage) {
        this.router.navigate(
          ['app/employee/list/added/', employeeData.id],
          {
            queryParams: { lowprofilepercent: true },
          },
        );
      } else {
        this.router.navigate(['app/employee/employee-dashboard']);
      }
    } else {
      this.router.navigate(['app']);
    }
  }

  private handleLoginError(err: any) {
    console.error('❌ Login Error:', err);

    if (err?.message?.includes('User')) {
      this.errMessageBlocked = err.message.split(': ')[1] || err.message;
    } else if (err?.message?.includes('Password')) {
      this.errMessageBlocked = err.message.split(': ')[1] || err.message;
    } else if (err?.message?.includes('Account blocked')) {
      this.errMessageEmail = '';
      this.errMessagePassword = '';
      this.errMessageBlocked = err.message.split(': ')[1] || err.message;
    } else if (err?.message?.includes('A password reset mail has already been sent to your registered email')) {
      this.toaster.failure(err.message);//forgot password 
    }
    else if (err?.message?.includes('Your account access has expired')) {
      this.toaster.failure(err.message);
    }
    else {
      this.toaster.failure('An unexpected error occurred during login.');
    }
  }

  togglePasswordVisibility() {
    this.passwordFieldType =
      this.passwordFieldType === 'password' ? 'text' : 'password';
  }

  onChnageInput(event: any, name: string) {
    let value = event.target.value;
    if (name == 'email') this.errMessageEmail = '';
    if (name == 'password') this.errMessagePassword = '';
  }

  forgotPass(username: any) {
    this.forgotPassword = !this.forgotPassword;
    this.submit = false;
    this.formdataChange(username);
  }

  formdataChange(username: any) {
    const commonValidators = [];

    const formFields: any = {
      username: [
        username,
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
          // Validators.pattern(this.userName),
        ],
      ],
    };

    if (!this.forgotPassword) {
      formFields['password'] = [
        '',
        [Validators.required, Validators.maxLength(64)],
      ];
    } else {
      // formFields['dateofbirth'] = ['', [Validators.required]];
    }

    this.formdata = this.formbulider.group(formFields);
  }

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
    // const apiCall = this.employeeService.updateEmployeeAcknowledge(this.userId, { type: 'Profile_Skipped' });
    // apiCall.subscribe({
    //   next: (resp: any) => {
    //     this.toaster.success('Skipped successfully');
    //     this.router.navigate(['app/employee/employee-dashboard']);
    //   }
    // })
  }

  clickProceed() {
    const parsedUser: any = localStorage.getItem('auth_user');
    const userDetails = JSON.parse(parsedUser);
    this.router.navigate(['app/employee/edit/' + userDetails.userID]);
  }
}
